import { Sparkle } from "./Sparkle";

const ITEMS = [
  "Precision",
  "Presence",
  "Quiet Luxury",
  "By Appointment Only",
  "Hair — Laser — Skin",
  "Brampton, Ontario",
];

export const Marquee = ({ dark = true }) => {
  const row = (key) => (
    <div key={key} className="flex items-center shrink-0">
      {ITEMS.map((item, i) => (
        <span key={i} className="flex items-center">
          <span
            className={`font-display text-2xl sm:text-4xl lg:text-5xl px-8 sm:px-12 whitespace-nowrap ${
              dark ? "text-ivory/25" : "text-espresso/20"
            }`}
          >
            {item}
          </span>
          <Sparkle size={14} className="opacity-50" />
        </span>
      ))}
    </div>
  );
  return (
    <div
      data-testid="editorial-marquee"
      className={`overflow-hidden py-10 sm:py-14 select-none ${
        dark ? "bg-espresso" : "bg-ivory"
      }`}
      aria-hidden="true"
    >
      <div className="marquee-track">
        {row("a")}
        {row("b")}
      </div>
    </div>
  );
};
